var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2659",
    "data-name": "Grupo 2659",
    transform: "translate(-115 -349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1795",
    "data-name": "Ret\\xE2ngulo 1795",
    width: 25,
    height: 25,
    rx: 6,
    transform: "translate(115 349)",
    fill: "#31352b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,2.83,2.83,5.66,8.5,0",
    transform: "translate(123.5 358.5)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.fa788570a95f3067c398e4a574b19242.svg";
export { ForwardRef as ReactComponent };